<template>
    <pg-page title="Private Gym Franchise"
             header="Jouw eigen Private Gym openen?"
             id="franchise"
    >

        <div class="mx-auto mt-4">
            <p class="lead mb-4">
                De eerste gym staat net, maar als jij nu al denkt: <em>wat een gaaf concept, dat wil ik ook</em> - neem dan even contact op voor de franchise opties.
            </p>
            <p class="lead mb-4">
                We ontwerpen en importeren zelf alle fitness apparatuur, zodat je deze tegen fabrieksprijzen kunt inkopen. We bouwen zelf de iOS en Android apps. Zowel voor leden, als voor jou als gym eigenaar. En we ontwikkelen eigen server en beveiligings software om de hardware in de gym aan te sturen. Alles is in-house, dus maximale flexibiliteit en integratie.
            </p>
            <p class="lead mb-4">
                Met andere woorden: als Private Gym franchise nemer wordt je van A tot Z compleet ontzorgd.
            </p>
            <p class="lead mb-4">
                Laat je nummer achter en dan bellen we je zo snel mogelijk terug.
            </p>
        </div>

        <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-0  border-bottom border-top py-4">
            <a type="button" class="btn btn-dark btn-lg px-4 me-sm-3 col-sm-6" @click.prevent="showFormModal = true">
                <i class="bi bi-chevron-right" style="margin-right: 12px;"></i>
                Contact mij
            </a>
            <a type="button" class="btn btn-success btn-lg px-4 col-sm-6" href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym%20voor%20Personal%20Trainers" rel="_blank">
                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i>
                <span style="display: inline-block;">
                                    WhatsApp
                                </span>
            </a>
        </div>


        <contact-modal
            v-if="showFormModal"
            @closed="showFormModal = false"
            type="franchise"
        ></contact-modal>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
export default {
    components: {ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
